export default __webpack_public_path__ + "static/media/message.c1e159d6.mp3";